import { GET_METHOD } from './ApiMethods';

export const getFullJobDetails = async (data) => {
    try {
        const params = {
            candidate_id: data.candidateId,
            job_id: data.jobId,
        };
        let response = await GET_METHOD('job/position', params);
        return response;
    } catch (error) {
        return error;
    }
};
